import React from 'react';
import { Section } from '../../types/Section';
import { DetailsSection } from './DetailsSection';
import { TextSection } from './TextSection';
import { PhotosSection } from './PhotosSection';
import { FilesSection } from './FilesSection';
import { SponsorListSection } from './SponsorListSection';

interface SectionRendererProps {
    section: Section;
}

export const SectionRenderer: React.FC<SectionRendererProps> = ({ section }) => {
    // Skip rendering if section is not visible
    if (section.visible === false) {
        return null;
    }

    // Select the appropriate component based on section type
    switch (section.type) {
        case 'details':
            return <DetailsSection section={section} />;
        case 'text':
            return <TextSection section={section} />;
        case 'photos':
            return <PhotosSection section={section} />;
        case 'files':
            return <FilesSection section={section} />;
        case 'sponsor_list':
            return <SponsorListSection section={section} />;
        default:
            console.warn(`Unknown section type: ${section.type}`);
            return null;
    }
};
